import { render, staticRenderFns } from "./dealerCampaign.vue?vue&type=template&id=0203da2e&scoped=true&"
import script from "./dealerCampaign.vue?vue&type=script&lang=js&"
export * from "./dealerCampaign.vue?vue&type=script&lang=js&"
import style0 from "./dealerCampaign.vue?vue&type=style&index=0&id=0203da2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203da2e",
  null
  
)

export default component.exports